import React, { useContext, useState } from 'react';
import { AuthContext } from './AuthContext';
import { CreateProductForm } from './CreateProductForm';
import { useHistory } from 'react-router-dom';
import useFetch from 'use-http';
import { Alert, AlertTitle, Button, Card, CardActionArea, CardActions, CardContent, Chip, CircularProgress, Grid, Modal, Stack } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { Link } from 'react-router-dom';

const useStyles = makeStyles({
    createContainer: {
        maxWidth: 700,
        backgroundColor: 'white',
        position: 'absolute',
        padding: 15,
        border: '1px solid gray',
        borderRadius: 5,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
    productTitle: {
        fontSize: 24,
        fontFamily: 'Dela Gothic One',
        padding: 0,
        margin: 0
    },
    productCard: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'stretch',
        padding: 10
    },
    productBody: {
        minHeight: 180,
        width: 350,
    },
    sales: {
        opacity: 0.8
    }
});

export const DashboardView = ({ onCreate }) => {
    const { address } = useContext(AuthContext);
    const [showModal, setModal] = useState(false);
    const history = useHistory();
    const classes = useStyles();

    const {
        loading: listingsLoading,
        error: listingsError,
        data: listings = []
    } = useFetch(`/users/${address}/listings`, []);

    const {
        loading: productsLoading,
        error: productsError,
        data: products = []
    } = useFetch(`/users/${address}/products`, []);

    const getSales = purchases => purchases
        .filter(p => p.status === 'verified')
        .map(p => p.price)
        .reduce((a, b) => a + b, 0);
        
    const getTotalSales = products => {
        const total = products.map(p => getSales(p.purchases)).reduce((a, b) => a + b, 0);
        return total > 0 ? <Stack style={{position: 'relative', bottom: -15}}><div style={{fontSize: 10, letterSpacing: 1}}>TOTAL SALES</div><h2 style={{paddingTop: 0, marginTop: 0}}>{`${total} ETH`}</h2></Stack> : null;
    }

    const loading = listingsLoading || productsLoading;
    const error = listingsError || productsError;

    if (error) {
        return (
            <Alert severity="error">
                <AlertTitle>Something went wrong</AlertTitle>
                {error.message}
            </Alert>
        );
    }

    if (loading) {
        return <CircularProgress style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}} />
    }

    return (
        <div>
            <Modal
                open={showModal}
                onClose={() => setModal(false)}
            >
                <div className={classes.createContainer}>
                    <CreateProductForm onSave={onCreate}/>
                </div>
            </Modal>
            <div className="row">
                <div className="col-12">
                    <Grid justifyContent="space-between" container direction="row" alignItems="center">
                        <Grid item>
                            <h2>Your Listings &mdash; <Button variant="contained" onClick={() => setModal(true)}> Create New</Button></h2>
                        </Grid>
                        <Grid style={{marginLeft: 'auto' }} item>
                            {getTotalSales(listings)}
                        </Grid>
                    </Grid>
                    
                    {listings.length === 0 && (
                        <div>
                            <div>No listings yet, got something to sell?</div>
                        </div>
                    )}
                    {listings.length > 0 && (
                        <Grid container direction="row" flexWrap='wrap' spacing={2}>
                            {listings.map(product => (
                                <Grid item key={product.id}>
                                    <Card className={classes.productCard} variant="outlined">
                                        <CardActionArea onClick={() => history.push(`/products/${product.id}`)}>
                                        <CardContent className={classes.productBody}>
                                            <h2 className={classes.productTitle}>{product.title}</h2>
                                        </CardContent>
                                        </CardActionArea>
                                        <CardActions spacing={8}>
                                            <Stack className={classes.sales}>
                                                <div style={{ fontSize: 10, textTransform: 'uppercase'}}>Sales</div>
                                                <div>{getSales(product.purchases)} ETH</div>
                                            </Stack>
                                            &nbsp;&nbsp;
                                            <Stack className={classes.sales}>
                                                <div style={{ fontSize: 10, textTransform: 'uppercase'}}># Sold</div>
                                                <div>{product.purchases.filter(p => p.status === 'verified').length}</div>
                                            </Stack>
                                            <div style={{marginLeft: 'auto'}}>
                                            <Button variant="outlined" component={Link} to={`/products/${product.id}/edit`} size="small">Edit</Button>
                                            </div>
                                        </CardActions>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    )}

                </div>
            </div>

            <div style={{ marginTop: 50, marginBottom: 50, borderTop: '1px solid gray' }}></div>

            <div className="row">
                <div>
                    <h2>Purchased Products</h2>
                </div>

                {products.length === 0 && (
                    <div>You haven't purchased anything yet</div>
                )}

                {products.length > 0 && (
                    <Grid container direction="row" flexWrap='wrap' spacing={2}>
                        {products.map(product => (
                            <Grid item key={product.id}>
                                <Card className={classes.productCard} variant="outlined">
                                    <CardActionArea onClick={() => history.push(`/products/${product.id}`)}>
                                        <CardContent className={classes.productBody}>
                                            <h2 className={classes.productTitle}>{product.title}</h2>
                                        </CardContent>
                                    </CardActionArea>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                )}
            </div>

        </div>
    );
};
